import { createReducer, on } from '@ngrx/store';

import { LoadingActions } from '../actions';
import { Loader } from '../models';

export interface State {
    loaders: Loader[];
}

export const initialState: State = {
    loaders: [],
};

export const loadingReducer = createReducer(
    initialState,
    on(LoadingActions.addLoader, (state, { id, loadingText }) => {
        return {
            ...state,
            loaders: [...state.loaders, { id, loadingText }],
        };
    }),
    on(LoadingActions.removeLoader, (state, { id }) => {
        return {
            ...state,
            loaders: state.loaders.filter((loader) => loader.id !== id),
        };
    }),
);
